import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { useParams } from "react-router-dom";
import { useMatchVendorsById } from "../../../legacy/hooks/useMatchVendorsById";
import { HgVendor } from "../../../types/taxonomy";
import { useMemo, useEffect } from "react";
import { VendorHeader } from "./VendorHeader";
import { VendorSummary } from "./VendorSummary";
import { ProductCountCard } from "./ProductCountCard";
import { CompanyCountCard } from "./CompanyCountCard";
import { InstallCountCard } from "./InstallCountCard";
import { VendorProductsTable } from "./VendorProductsTable/VendorProductsTable";
import { VendorBreadcrumbs } from "./VendorBreadcrumbs";
import { useCommandPaletteStore } from "@/store/commandPalette/commandPaletteStore";

export const VendorPage = () => {
  const { vendorId } = useParams<{ vendorId: string }>();
  const addRecentItem = useCommandPaletteStore((s) => s.addRecentItem);

  const { matchedVendorsById, loading } = useMatchVendorsById({
    ids: vendorId ? [Number.parseInt(vendorId)] : [],
  });

  const vendor = useMemo<HgVendor>(() => {
    if (matchedVendorsById.length === 0) {
      return {
        id: 0,
        name: "unknown",
        description: undefined,
        url: "unknown",
      };
    }

    return matchedVendorsById[0];
  }, [matchedVendorsById]);

  useEffect(() => {
    if (vendor?.id && vendor?.name) {
      addRecentItem({
        id: String(vendor.id),
        type: "vendor",
        name: vendor.name,
        route: `/catalog/product/vendor/${vendor.id}`,
      });
    }
  }, [vendor?.id, vendor?.name, addRecentItem]);

  return (
    <Stack gap={3}>
      <VendorBreadcrumbs vendorName={vendor.name} isLoading={loading} />

      <VendorHeader vendorName={vendor.name} isLoading={loading} />

      <VendorSummary
        vendorId={vendor.id}
        isLoading={loading}
        vendorUrl={vendor.url}
        vendorName={vendor.name}
        vendorDescription={vendor.description}
      />

      <Box display="flex" gap={2} justifyContent="space-between">
        <ProductCountCard vendorId={vendor.id} />
        <CompanyCountCard vendorId={vendor.id} />
        <InstallCountCard vendorId={vendor.id} />
      </Box>

      <VendorProductsTable
        vendorName={vendor.name}
        vendorId={vendor.id}
        isLoading={loading}
      />
    </Stack>
  );
};
